import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
import PrintCustomNiceloopV1Builder from "~/class/printer/PrintCustomNiceloopV1Builder";


export default class ThermalPrintVoidReport extends ThermalPrinterBase {  
    printVoid(payload:any){            
        const voidData = this.withPayload(payload)       
        this.print_data = voidData
        return this
    }

    withPayload(payload:any){
        return new PrintCustomNiceloopV1Builder().makeVoidReport(payload).build();
    }

    setPayload(payload:any){
        this.print_data = payload
        return this
    }
}
